import React from "react";
// width={data.w} height={data.h}
function Icon(data) {
  return (
     <svg
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
      xmlSpace="preserve"
      style={{
        fillRule: "evenodd",
        clipRule: "evenodd",
        strokeLinejoin: "round",
        strokeMiterlimit: 2,
      }}
      width={data.w} height={data.h}
    >
      <path
        d="M27.3 20.08a4.458 4.458 0 0 1-2.3-.64 22.504 22.504 0 0 1-3.55-2.9l-.66-.62a3.014 3.014 0 0 0-4.22 0l-2 2.06a.752.752 0 0 1-.511.201.753.753 0 0 1-.75-.75c0-.189.072-.372.201-.511l2.05-2.06c1.73-1.707 4.55-1.707 6.28 0l.68.63a20.758 20.758 0 0 0 3.34 2.74c1.61 1 3.81 0 5.18-1.12a19.667 19.667 0 0 0 2-2 .759.759 0 0 1 1.14 1 19.835 19.835 0 0 1-2.14 2.14 7.692 7.692 0 0 1-4.74 1.83Z"
        style={{
          fill: "#3d3833",
          fillRule: "nonzero",
        }}
        transform="translate(-28.145 -24.904) scale(2.1774)"
      />
      <path
        d="M27.53 25.64A4.541 4.541 0 0 1 25.2 25a23.114 23.114 0 0 1-3.56-2.91l-.64-.6a3.013 3.013 0 0 0-4.21 0l-2.06 2.05a.752.752 0 0 1-.549.239.754.754 0 0 1-.75-.75c0-.208.087-.407.239-.549l2.06-2.05c1.724-1.711 4.546-1.711 6.27 0l.67.63A21.248 21.248 0 0 0 26 23.74c1.62 1 3.81 0 5.19-1.12a19.508 19.508 0 0 0 1.95-1.95.75.75 0 0 1 1.06-.09.773.773 0 0 1 .09 1.06 22.977 22.977 0 0 1-2.15 2.14 7.647 7.647 0 0 1-4.61 1.86Z"
        style={{
          fill: "#dfa370",
          fillRule: "nonzero",
        }}
        transform="translate(-28.145 -24.904) scale(2.1774)"
      />
      <path
        d="M27.65 31.34a4.409 4.409 0 0 1-2.33-.64 21.958 21.958 0 0 1-3.55-2.9l-.67-.62a3.013 3.013 0 0 0-4.21 0l-2.05 2a.753.753 0 0 1-1.284-.53c0-.2.081-.391.224-.53l2.05-2.06c1.726-1.706 4.544-1.706 6.27 0l.69.63a21.178 21.178 0 0 0 3.33 2.74c1.62 1 3.82 0 5.19-1.12a18.984 18.984 0 0 0 1.95-2 .773.773 0 0 1 1.06-.09.75.75 0 0 1 .09 1.06 19.835 19.835 0 0 1-2.14 2.14 7.632 7.632 0 0 1-4.62 1.92Z"
        style={{
          fill: "#3d3833",
          fillRule: "nonzero",
        }}
        transform="translate(-28.145 -24.904) scale(2.1774)"
      />
    </svg>

  );
}

export default Icon;
